/** Local-date label for an ISO timestamp, or null when it is absent or unparseable. */
export function formatBillingDate(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString()
}
